import { InfoAdapterType } from "features/shared/types/info";
import { TableDefinition } from "features/shared/types/table";
import { Tag } from "features/shared/types/tag";

const TAG_TABLE: TableDefinition<Tag> = {
    rowTemplate: [
        {
            header: "Key",
            accessor: "key",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Name (EN)",
            accessor: "value:name:en",
            rowAccessor: (row) => {
                switch (row.value?.type) {
                    case InfoAdapterType.DefaultInfo:
                        return row.value.name?.en;
                    case InfoAdapterType.StringInfo:
                        return row.value.value;
                }
            },
            flex: 2.5,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Name (TH)",
            accessor: "value:name:th",
            flex: 2.5,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "View Count",
            accessor: "value:viewCount",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Rank",
            accessor: "value:rank",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "SEO",
            accessor: "value:seo",
            flex: 2.5,
            isShown: true,
            minCellWidth: 150,
        },
        {
            header: "Description (EN)",
            accessor: "value:description:en",
            flex: 2.5,
            isShown: true,
            minCellWidth: 400,
        },
        {
            header: "Description (TH)",
            accessor: "value:description:th",
            flex: 2.5,
            isShown: true,
            minCellWidth: 400,
        },
        {
            header: "Image",
            accessor: "value:image",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
        {
            header: "Linked Article ID",
            accessor: "value:linkedArticleId",
            flex: 3,
            isShown: true,
            minCellWidth: 200,
        },
    ],
    defaultSortKey: "key",
};

export default TAG_TABLE;
